<template>
  <div class="body">
    <el-container>
      <!-- <Aside @toggle="toggle($event)" /> -->
      <el-main>
        <el-row :gutter="10">
          <el-col :xl="9" :lg="9" :md="6" :sm="12">
            <div class="bg-White h">
              <SearchSuppliers
                :searchOnly="true"
                :supplier="supplier"
                @selectedSupplier="selectedSupplier"
                :productsLength="productsLength"
                :productSearch="false"
                :showLabel="true"
              />
            </div>
          </el-col>
          <el-col :xl="9" :lg="9" :md="6" :sm="12" class="bg-White">
            <div class="block p-3 mt-2">
              <label for="" class="d-block"> اختر مده زمنيه</label>
              <el-date-picker
                style="width: 100%"
                @change="selectDateRange"
                v-model="dateRange"
                type="daterange"
                range-separator="الي"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
                start-placeholder="بداية الفترة"
                end-placeholder="نهاية الفترة"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col :xl="6" :lg="6" :md="7" :sm="24" v-if="supplier">
            <div class="bg-White result">
              <p class="p-3 mt-2">
                <span
                  class="num"
                  v-if="
                    +supplier.balance + +supplier.account >= 0
                  "
                  >{{
                    numberToFixed(
                      +supplier.balance + +supplier.account
                    )
                  }}</span
                >
                <span class="num" v-else>{{
                  numberToFixed(
                    +supplier.balance + +supplier.account * -1
                  )
                }}</span>
                <br />
                <span
                  v-if="
                    +supplier.balance + +supplier.account >= 0
                  "
                  >دائن</span
                >
                <span v-else>مدين</span>
              </p>
            </div>
          </el-col>
        </el-row>
        <el-row
          class="bg-White mt-2 p-3"
          v-if="supplier"
          justify="space-between"
        >
          <el-col :xl="3" :lg="3" :md="6" :sm="12"> الفواتير </el-col>
          <el-col :xl="6" :lg="6" :pull="15" :md="6" :sm="12">
            <label for="code"></label>
            <el-input
              @change="selectSearchCode"
              placeholder="بحث بالفاتورة "
              autofocus
              type="text"
              @focus="$event.target.select()"
              v-model="searchCode"
            ></el-input>
          </el-col>
        </el-row>
        <el-table
          v-infinite-scroll="loadMoreData"
          class="mt-2"
          align="right"
          style="overflow: auto"
          v-if="tableData.length > 0"
          :data="tableData"
          border
        >
          <!-- style="width: 100%" -->
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <el-table-column sortable width="100" label="الفاتورة" prop="id">
          </el-table-column>
          <el-table-column label="القيمة" prop="total_cost"> </el-table-column>
          <el-table-column label="الخصم" prop="discount"> </el-table-column>
          <el-table-column label="مرتجع" prop="returned_amount">
          </el-table-column>
          <el-table-column label="الاجمالي" prop="total">
            <template slot-scope="scope">
              {{
                scope.row.total_cost -
                scope.row.returned_amount -
                scope.row.discount
              }}
            </template>
          </el-table-column>
          <el-table-column
            width="180"
            label="عدد المنتجات"
            prop="products.length"
          >
          </el-table-column>
          <el-table-column
            width="170"
            sortable
            label="التوقيت"
            prop="created_at"
          >
            <template slot-scope="scope">
              {{scope.row.created_at | moment("Do / MM / YYYY | h:mm A")}}
            </template>
          </el-table-column>
          <el-table-column label="اجراءات" width="120">
            <template slot-scope="scope">
              <el-row :gutter="10">
                <el-col :lg="12">
                  <router-link
                    title="تعديل الفاتورة"
                    :to="{ path: '/purchases/return/' + scope.row.id }"
                  >
                    <el-button size="mini" type="danger">
                      انشاء مرتجع
                    </el-button>
                  </router-link>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column type="expand" align="left">
            <template slot-scope="props">
              <el-table
                class="mt-2"
                align="right"
                :data="props.row.products"
                border
                style="width: 80%; margin: auto"
              >
                <el-table-column label="#" type="index" width="50">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column label="المنتج " prop="name"></el-table-column>
                <el-table-column sortable width="100" label="الكمية ">
                  <template slot-scope="scope">{{
                    scope.row.pivot.qty - scope.row.pivot.returned_qty
                  }}</template>
                </el-table-column>
                <el-table-column
                  width="100"
                  label="السعر "
                  prop="pivot.buy_cost"
                ></el-table-column>
                <el-table-column label="الاجمالي">
                  <template slot-scope="scope">
                    {{ (Number(scope.row.pivot.qty) - Number(scope.row.pivot.returned_qty)) * scope.row.pivot.buy_cost }}
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Aside from "@/components/aside.vue";
import SearchSuppliers from "@/components/Suppliers/SearchWithoutAdd.vue";
import axiosApi from "@/plugins/axios.js";
export default {
  name: "ReturnProduct",
  components: { Aside, SearchSuppliers },
  data() {
    return {
      productsLength: 0,
      supplier: null,
      filterMode: false,
      tableData: [],
      pagination: {
        current_page: 1,
        last_page: 1,
      },
      dateRange: null,
      searchCode: "",
      supplierAccount: this.supplier
        ? this.supplier.balance + Number(this.supplier.account)
        : 0,
    };
  },
  methods: {
    selectedSupplier(e) {
      this.supplier = e.supplier;
      this.filterMode = true;
      this.getPurchases();
    },
    selectDateRange() {
      this.filterMode = true;
      this.getPurchases();
    },
    selectSearchCode() {
      this.filterMode = true;
      this.getPurchases();
    },
    getPurchases() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (this.filterMode) {
        this.tableData = [];
      }
      let url = `inventory-purchases/${
        JSON.parse(localStorage.getItem("user_inventories"))[0].id
      }?page=${this.pagination.current_page}`;
      if (this.dateRange != null) {
        url += "&start_date=" + this.dateRange[0];
        url += "&end_date=" + this.dateRange[1];
      }
      if (this.searchCode.trim() != "") {
        url += "&code=" + this.searchCode;
      }
      if (this.supplier != null) {
        url += "&supplier=" + this.supplier.id;
      }
      axiosApi
        .get(url)
        .then((res) => {

            this.tableData = res.data.data;
            this.pagination = res.data.meta;
            this.tableData.map((invoice) => {
              invoice.total = this.numberToFixed(
                invoice.total_cost - invoice.discount
              );
              invoice.total_cost = this.numberToFixed(invoice.total_cost);
              invoice.discount = this.numberToFixed(invoice.discount);
            });

        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
          this.filterMode = false;
        });
    },
    numberToFixed(number) {
      return Number(number).toFixed(2);
    },
    loadMoreData() {
      if (this.pagination.last_page > this.pagination.current_page) {
        this.pagination.current_page++;
        this.getPurchases();
      }
    },
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  max-height: 72%;
  overflow-y: scroll;
}
</style>
